import * as THREE from "three";
import { useTexture } from "@react-three/drei";
import { useEffect, useMemo } from "react";
import path from "../path";

export default function SmartPhoneInterface(props) {
  const { size, uv, uv2 } = props;

  const texture = useTexture(path + "/assets/swap-spritesheet.png");

  // create geometry with correct UV
  const geom = useMemo(() => {
    const geom = new THREE.PlaneBufferGeometry(size[0], size[1]);
    const uvatt = geom.attributes.uv;
    uvatt.setXY(2, uv[0], uv[1]);
    uvatt.setXY(3, uv[0] + uv2[0], uv[1]);
    uvatt.setXY(0, uv[0], uv[1] + uv2[1]);
    uvatt.setXY(1, uv[0] + uv2[0], uv[1] + uv2[1]);
    return geom;
  }, []);

  // update texture after load
  useEffect(() => {
    texture.premultiplyAlpha = true;
    texture.needsUpdate = true;
  }, [texture]);

  return (
    <mesh {...props} geometry={geom}>
      <meshStandardMaterial
        attach="material"
        map={texture}
        transparent={true}
        flatShading={true}
        opacity={0.4}
        alphaTest={0.1}
      />
    </mesh>
  );
}
